module.exports = __webpack_public_path__ + "img/close.aeda79fa.svg";